import React from "react";
import {PaymentDetails} from "./PaymentDetailsContainer";

const PaymentDetailsWrapper = ({ children }) => {
    const paymentDetailsProps = PaymentDetails.useContainer();
    return (
        <>
          {children({...paymentDetailsProps })}
        </>
    )
}

export default PaymentDetailsWrapper;
